import BaseService from './_base.service';

export const rentaluserService = {
    page,
    search,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/user/rental/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/user/rental/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/user/rental/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/user/rental/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/user/rental/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/user/rental/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/user/rental/"+id+"/logic", callback);
}
